import React, { createContext, useState } from "react";
import userProfileFormInitialValue from "../views/UserProfile/FormModel/userProfileFormInitialValue";

export const UserContext = createContext();

// This context provider is passed to any component requiring the context
export const UserProvider = ({ children }) => {
    const [data, setData] = useState(userProfileFormInitialValue);

    return (
        <UserContext.Provider
            value={{
                data,
                setData
            }}
        >
            {children}
        </UserContext.Provider>
    );
};